import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../context/GlobalState';
import ProfileModal from './ProfileModal';
import ThemeToggle from './ThemeToggle';


function Header() {
  const { user, setSaveProfileIsOpen } = useGlobalState();
  const navigate = useNavigate();

  const goHome = () => {
    navigate(`/`);
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'absolute',
      top: '10px',
      left: '0',
      width: '100%',
      padding: '0 20px',
      boxSizing: 'border-box',
      zIndex: 1000,
      fontFamily: 'Cinzel, serif',
      fontSize: '30px',
      color: 'var(--accent)',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      textShadow: '2px 2px 4px var(--shadow-main)'
    }}>
      <div>
        <span onClick={goHome} style={{ cursor: 'pointer' }}>{'DEUS'}</span>
      </div>
      <div style={{
        fontSize: '16px',  // Smaller font size for subtext
        textAlign: 'center',
        marginTop: '5px',  // Space between title and subtext
      }}>
        GOD IN YOVR MACHINE
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <ThemeToggle />
        <button 
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'var(--accent)';
            e.target.style.color = 'var(--background-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = 'var(--accent)';
          }}
          style={{
            backgroundColor: 'transparent',
            color: 'var(--accent)',
            border: '2px solid var(--accent)',
            borderRadius: 'var(--border-radius-md)',
            padding: '10px 20px',
            cursor: 'pointer',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            textShadow: '1px 1px 2px var(--shadow-main)',
            marginRight: '0',
            transition: 'all var(--transition-short)'
          }}
          onClick={() => setSaveProfileIsOpen(true)}
        >
          {user?.username || 'Account'}
        </button>
      </div>
      <ProfileModal />
    </div>
  );
}

export default Header; 